/*
  Leaflet.AwesomeMarkers, a plugin that adds colorful iconic markers for Leaflet, based on the Font Awesome icons
  (c) 2012-2013, Lennard Voogdt

  ES6 Version by Theme 2019

  http://leafletjs.com
  https://github.com/lvoogdt
*/

/* global L */
import * as L from 'leaflet'

L.AwesomeMarkers = {}

L.AwesomeMarkers.version = '2.0.4';

L.AwesomeMarkers.Icon = L.Icon.extend({
  options: {
    iconSize: [35, 45],
    iconAnchor: [17, 42],
    popupAnchor: [1, -32],
    shadowAnchor: [10, 12],
    shadowSize: [36, 16],
    className: 'awesome-marker',
    prefix: 'glyphicon',
    spinClass: 'fa-spin',
    extraClasses: '',
    icon: 'home',
    markerColor: 'blue',
    iconColor: 'white',
    html: ''
  },

  initialize (options) {
    options = L.Util.setOptions(this, options)
  },

  createIcon () {
    let div = document.createElement('div'),
      options = this.options

    if (options.icon) {
      div.innerHTML = this._createInner()
    }

    if (options.bgPos) {
      div.style.backgroundPosition =
        (-options.bgPos.x) + 'px ' + (-options.bgPos.y) + 'px'
    }

    this._setIconStyles(div, 'icon-' + options.markerColor)
    return div
  },

  _createInner () {
    let iconClass, iconSpinClass = '', iconColorClass = '', iconColorStyle = ''
    const options = this.options

    if (options.icon.slice(0, options.prefix.length + 1) === options.prefix + '-') {
      iconClass = options.icon
    } else {
      iconClass = options.prefix + '-' + options.icon
    }

    if (options.spin && typeof options.spinClass === 'string') {
      iconSpinClass = options.spinClass
    }

    if (options.iconColor) {
      if (options.iconColor === 'white' || options.iconColor === 'black') {
        iconColorClass = 'icon-' + options.iconColor
      } else {
        iconColorStyle = "style='color: " + options.iconColor + "' "
      }
    }

    return '<i ' + iconColorStyle + "class='" + options.extraClasses + ' ' + options.prefix + ' ' + iconClass + ' ' + iconSpinClass + ' ' + iconColorClass + "'>" + options.html + "</i>"
  },

  _setIconStyles (img, name) {
    const options = this.options
    let size = L.point(options[name === 'shadow' ? 'shadowSize' : 'iconSize']),
      anchor

    if (name === 'shadow') {
      anchor = L.point(options.shadowAnchor || options.iconAnchor)
    } else {
      anchor = L.point(options.iconAnchor)
    }

    if (!anchor && size) {
      anchor = size.divideBy(2, true)
    }

    img.className = 'awesome-marker-' + name + ' ' + options.className

    if (anchor) {
      img.style.marginLeft = (-anchor.x) + 'px'
      img.style.marginTop = (-anchor.y) + 'px'
    }

    if (size) {
      img.style.width = size.x + 'px'
      img.style.height = size.y + 'px'
    }
  },

  createShadow () {
    const div = document.createElement('div')

    this._setIconStyles(div, 'shadow')
    return div
  }
})

L.AwesomeMarkers.icon = (options) => new L.AwesomeMarkers.Icon(options)

export let AwesomeMarkers = L.AwesomeMarkers



// WEBPACK FOOTER //
// ./src/assets/js/leaflet/leaflet.awesome-markers.js